// extracted by mini-css-extract-plugin
export default {"text":"ProductFabricInfo__text___O3lxp","button":"ProductFabricInfo__button____XRPr"};